<script setup lang="ts">
import { services } from '~/components/services/relax';

const text = 'Kde tělo odpočívá a mysl ožívá.';
</script>

<template>
  <NavbarDropdownTab :title="text" :services />
</template>
